import { Type } from "../models/treeSelector/models"
import {
    AccountCodeFieldDefinitionType,
    ActivityFieldDefinitionType,
    ApplicationFieldDefinitionType,
    ApplicationVersionFieldDefinitionType,
    BillTypeFieldDefinitionType,
    DisplayTypeFieldDefinitionType,
    ImpactFieldDefinitionType,
    OptionFieldDefinitionType,
    OptionsFieldDefinitionType,
    ProbabilityFieldDefinitionType,
    TagsFieldDefinitionType,
    UserFieldDefinitionType,
    UserGroupFieldDefinitionType,
    UserGroupsFieldDefinitionType,
    UsersFieldDefinitionType,
} from "../utils/conditions/SelectorConditionParser"

export const ItemFieldToFieldDefinitionType: Partial<Record<Type, string>> = {
    "TF.OptionItemField": OptionFieldDefinitionType.replace("#", ""),
    "TF.OptionsItemField": OptionsFieldDefinitionType.replace("#", ""),
    "TF.AccountCodeItemField": AccountCodeFieldDefinitionType.replace("#", ""),
    "TF.ActivityItemField": ActivityFieldDefinitionType.replace("#", ""),
    "TF.ApplicationItemField": ApplicationFieldDefinitionType.replace("#", ""),
    "TF.ApplicationVersionItemField":
        ApplicationVersionFieldDefinitionType.replace("#", ""),
    "TF.BillTypeItemField": BillTypeFieldDefinitionType.replace("#", ""),
    "TF.DisplayTypeItemField": DisplayTypeFieldDefinitionType.replace("#", ""),
    "TF.ImpactItemField": ImpactFieldDefinitionType.replace("#", ""),
    "TF.ProbabilityItemField": ProbabilityFieldDefinitionType.replace("#", ""),
    "TF.UserGroupItemField": UserGroupFieldDefinitionType.replace("#", ""),
    "TF.UserGroupsItemField": UserGroupsFieldDefinitionType.replace("#", ""),
    "TF.UserItemField": UserFieldDefinitionType.replace("#", ""),
    "TF.UsersItemField": UsersFieldDefinitionType.replace("#", ""),
    "TF.TagsItemField": TagsFieldDefinitionType.replace("#", ""),
} as const
